import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { computed, defineComponent, toRefs } from "@vue/composition-api";
import { uniqueId } from "lodash";
import NumberField from "@Shared/components/form-elements/fields/number-field.vue";
export default defineComponent({
  name: "PercentageField",
  components: {
    NumberField
  },
  props: {
    value: {
      type: null,
      default: 0
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: null
    },
    digits: {
      type: Number,
      default: 3
    },
    digitsOptional: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    sideGrid: {
      type: Boolean,
      default: false
    },
    noDecimals: {
      type: Boolean,
      default: false
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const {
      value,
      noDecimals
    } = toRefs(props);
    const maskType = computed(() => {
      return noDecimals.value ? "integer" : "percentage";
    });
    const {
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      valueModel
    } = useCoreInput({
      value
    });
    return {
      valueModel,
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      maskType
    };
  }
});